<template>
    <inverter-table-list></inverter-table-list>
</template>

<script>
    import inverterTableList from "../../components/inverterList/inverterTableList";
    export default {
        name: "inverterList",
        components:{
            inverterTableList
        }
    }
</script>

<style scoped>

</style>